import React from 'react'
export const Avatar: React.FunctionComponent = (props) => {
  return <img src='Avatar.svg' alt='' style={{ width: '210px' }} />

}
